import styled from 'styled-components';

import Image from '../Image';
import ButtonLink from '../interface/ButtonLink';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
`;

export const CtaButton = styled(ButtonLink)`
  align-self: flex-end;
  margin-top: auto;
`;

export const Header = styled.header`
  max-width: 25rem;
  padding: 4rem 0 0 4rem;
`;

export const ImageOverlay = styled.div`
  width: 100%;
  height: 100%;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0.5) 0%,
    rgba(0, 0, 0, 0) 37.5%,
    rgba(0, 0, 0, 0) 62.5%,
    rgba(0, 0, 0, 0.5) 100%
  );
  position: absolute;
  top: 0;

  @media (${({ theme }) => theme.respondTo.tablet}) {
    background: linear-gradient(90deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0) 100%);
  }
`;

export const ImageWrapper = styled.div`
  width: 100%;
  position: absolute;

  > * {
    height: 31.5rem;
    border-top-right-radius: 15rem;

    @media (${({ theme }) => theme.respondTo.tablet}) {
      height: 30rem;
      border-top-right-radius: 12rem;
    }
  }
`;

export const StyledImage = styled(Image)`
  display: block;
`;

export const Subtitle = styled.span`
  display: block;
  margin-bottom: 1.5rem;
`;

export const Title = styled.h3`
  font-family: var(--font-tertiary);
  font-weight: var(--font-weight-bold);
  font-size: 2.1rem;
  line-height: 1.24;
  margin: 0;

  @media (${({ theme }) => theme.respondTo.tablet}) {
    font-size: 2.5rem;
  }
`;

export const Wrapper = styled.div`
  height: 31.5rem;
  position: relative;

  @media (${({ theme }) => theme.respondTo.tablet}) {
    height: 30rem;
  }

  &:nth-child(even) {
    ${ImageWrapper} {
      > * {
        @media (${({ theme }) => theme.respondTo.tablet}) {
          border-bottom-left-radius: 12rem;
        }
      }
    }
  }
`;
